import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Template } from "@/types/models";
import TemplateForm from "@/components/TemplateForm";

interface TemplateFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultValues?: Partial<Template>;
  onSave?: (data: { name: string; description: string; is_active: boolean; template_type_id: number | null; template_formatetype_ids: number[] }) => Promise<void>;
}

export function TemplateFormDialog({ open, onOpenChange, defaultValues, onSave }: TemplateFormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{defaultValues?.id ? "Edit Template" : "Create Template"}</DialogTitle>
        </DialogHeader>
        <TemplateForm
          onClose={() => onOpenChange(false)}
          defaultValues={defaultValues ? {
            id: defaultValues.id,
            name: defaultValues.name,
            description: defaultValues.description ?? undefined,
            is_active: defaultValues.is_active,
            template_type_id: defaultValues.template_type_id ?? null,
            template_formatetype_ids: defaultValues.template_formatetype_ids ?? [],
          } : undefined}
          onSave={onSave}
        />
      </DialogContent>
    </Dialog>
  );
}
